import { h } from 'preact'
import { Block, InlineBlock } from 'jsxstyle/preact'
import { Fragment } from 'preact'

export const ColorInput = ({ value, label, onChange }) => {
  return (
    <Fragment>
      {label && <Block>{label}</Block>}
      <InlineBlock
        component="Input"
        props={{
          type: 'color',
          value,
          onChange: (e) => onChange(e.target.value)
        }}
      />
    </Fragment>
  )
}
